/** Die zehn Herdenpferde des Sternentals, eins pro Einmaleins-Reihe. */
export const HERDENPFERDE = [
  { reihe: 1, gebiet: 'Sonnenbach', name: 'Kiesel', fell: 'Falbe' },
  { reihe: 2, gebiet: 'Blumenwiese', name: 'Mohnblume', fell: 'Fuchs' },
  { reihe: 3, gebiet: 'Birkenhain', name: 'Flocke', fell: 'Schimmel' },
  { reihe: 4, gebiet: 'Mühlenteich', name: 'Hafer', fell: 'Palomino' },
  { reihe: 5, gebiet: 'Apfelgarten', name: 'Krümel', fell: 'Schecke' },
  { reihe: 6, gebiet: 'Heidehügel', name: 'Silbermond', fell: 'Apfelschimmel' },
  { reihe: 7, gebiet: 'Nebelwald', name: 'Nebelmond', fell: 'Rappe' },
  { reihe: 8, gebiet: 'Schilfsee', name: 'Wirbel', fell: 'Brauner' },
  { reihe: 9, gebiet: 'Felsenschlucht', name: 'Funke', fell: 'Dunkelfuchs' },
  { reihe: 10, gebiet: 'Sternengipfel', name: 'Polarstern', fell: 'Schimmel' },
] as const
